module.exports = __webpack_public_path__ + "img/dining-program-banner_0.102c2bc5.jpg";